export function addCoreSources(map, data) {
  map.addSource('parcels', {
    type: 'geojson',
    data: data.parcels,
    promoteId: 'id',
  });

  map.addSource('natura2000', {
    type: 'geojson',
    data: data.natura2000,
  });

  map.addSource('buffer-zones', {
    type: 'geojson',
    data: data.bufferZones,
  });
}

export function addWaterSource(map, water) {
  map.addSource('water', {
    type: 'geojson',
    data: water,
  });
}
